import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { addCustomAttributes, getAddStringContext, nullable, numeric } from '../../../common/serialize/bel-serializer';
import { NODE_TYPE } from '../constants';
import { BelNode } from './bel-node';
export var AjaxNode = /*#__PURE__*/function (_BelNode) {
  _inherits(AjaxNode, _BelNode);

  var _super = _createSuper(AjaxNode);

  function AjaxNode(agentIdentifier, ajaxEvent) {
    var _this;

    _classCallCheck(this, AjaxNode);

    _this = _super.call(this, agentIdentifier);
    _this.belType = NODE_TYPE.AJAX;
    _this.method = ajaxEvent.method;
    _this.status = ajaxEvent.status;
    _this.domain = ajaxEvent.domain;
    _this.path = ajaxEvent.path;
    _this.txSize = ajaxEvent.requestSize;
    _this.rxSize = ajaxEvent.responseSize;
    _this.requestedWith = ajaxEvent.type === 'fetch' ? 1 : ''; // 'xhr' and 'beacon' types get the empty string

    _this.spanId = ajaxEvent.spanId;
    _this.traceId = ajaxEvent.traceId;
    _this.spanTimestamp = ajaxEvent.spanTimestamp;
    _this.gql = ajaxEvent.gql;
    _this.start = ajaxEvent.startTime; // 5000 --- 5500 --> 10500

    _this.end = ajaxEvent.endTime;
    return _this;
  }

  _createClass(AjaxNode, [{
    key: "serialize",
    value: function serialize(parentStartTimestamp) {
      var addString = getAddStringContext(this.agentIdentifier);
      var nodeList = []; // IMPORTANT: The order in which addString is called matters and correlates to the order in which string shows up in the harvest payload. Do not re-order the following code.

      var fields = [numeric(this.belType), 0, // this will be overwritten below with number of attached nodes
      numeric(this.start - parentStartTimestamp), // start relative to parent start (if part of first node in payload) or first parent start
      numeric(this.end - this.start), // end is relative to start
      numeric(this.callbackEnd), numeric(this.callbackDuration), addString(this.method), numeric(this.status), addString(this.domain), addString(this.path), numeric(this.txSize), numeric(this.rxSize), this.requestedWith, addString(this.nodeId), nullable(this.spanId, addString, true) + nullable(this.traceId, addString, true) + nullable(this.spanTimestamp, numeric)];
      var allAttachedNodes = [];
      if (_typeof(this.gql) === 'object') allAttachedNodes = addCustomAttributes(this.gql, addString);
      this.children.forEach(function (node) {
        return allAttachedNodes.push(node.serialize());
      }); // no children is expected under ajax nodes at this time

      fields[1] = numeric(allAttachedNodes.length);
      nodeList.push(fields);
      if (allAttachedNodes.length) nodeList.push(allAttachedNodes.join(';'));
      return nodeList.join(';');
    }
  }]);

  return AjaxNode;
}(BelNode);